import React from "react";
import { useLanguage } from "@/contexts/LanguageContext";

interface SectionHeaderProps {
  isDualAssessment: boolean;
  selectedWordsCount: number;
  selfWordsCount: number;
  workWordsCount: number;
}

const SectionHeader: React.FC<SectionHeaderProps> = ({
  isDualAssessment,
  selectedWordsCount,
  selfWordsCount,
  workWordsCount,
}) => {
  const { t } = useLanguage();

  return (
    <div className="mb-12">
      <h2 className="text-2xl font-semibold text-foreground mb-2">
        {isDualAssessment 
          ? `${t('results.personalityStory.selfVsWork')} ${t('results.personalityStory.analysis')}`
          : `${t('results.personalityStory.theDataBehind')} ${t('results.personalityStory.yourUniqueness')}`
        }
      </h2>
      <p className="text-muted-foreground">
        {isDualAssessment
          ? t('results.personalityStory.compareDescription', { selfWordsCount, workWordsCount })
          : t('results.personalityStory.basedOnWords', { selectedWordsCount })}
      </p>
    </div>
  );
};

export default SectionHeader;
